import { Component, Inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DEFAULTVALUES } from 'src/app/constants/defaultValues';
import {
  IHomePage,
  ILeaseProcessCard,
  ILeaseProcessB
} from 'src/app/model/http/homepage.model';
import { DataService } from 'src/app/services/data.service';
import { StrappiService } from 'src/app/services/strappi.service';
import { WINDOW } from 'src/app/utils/window';
import { Endpoints } from 'src/environments/endpoints';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-lease-process',
  templateUrl: `./lease-process.component${environment.templateSuffix}.html`,
  styleUrls: ['./lease-process.component.scss'],
})
export class LeaseProcessComponent implements OnDestroy {
  screenWidth: any = this.window.innerWidth;
  
  leaseProcessCards: ILeaseProcessCard[] = [];
  title: any = DEFAULTVALUES.home_leaseProcess.defaultTitle;
  subTitle: any = DEFAULTVALUES.home_leaseProcess.defaultSubtitle;
  leaseProcess: IHomePage = {};
  // leaseProcessB: ILeaseProcessB[] = [];

  subscriptionDataHomepage!: Subscription;
  subscriptionScreen!: Subscription;
  screenSize = this.window.innerWidth;
  constructor(
    private strappiService: StrappiService, 
    private dataService: DataService,
    @Inject(WINDOW) private window: Window) {
    this.subscriptionDataHomepage = this.strappiService.getDataHomepage().subscribe((res) => {
      this.leaseProcess = res;
      /* Se modificó la validación para recibir los datos de strapi de B a A en Home === ''*/
     /*  if(environment.templateSuffix !== '')
        this.getContent(this.leaseProcess);
      else */
      // TODO: flowb validar que recibe esta funcion 
        // this.processFlowB(res.lease_process)
    });

    this.subscriptionScreen = this.dataService.getScreenSize().subscribe(resp => this.screenWidth = resp);
  }

  ngOnDestroy(): void {
    this.subscriptionDataHomepage.unsubscribe();
  }

  // TODO: validarque revibe y si hay que quitarla 
  /* processFlowB(data: any){
    data.forEach((item: any) => {
      this.leaseProcessB.push({
        id: item,
        title: item.title,
        description: item.description,
        img: `${Endpoints.strappi.base}${item.img.url}`
      })
    })
  } */

  getContent(data: any) {
    this.title = data.proceso_arrendamiento?.header.title;
    this.subTitle = data.proceso_arrendamiento?.header.subtitle;
    data.proceso_arrendamiento?.pasos.slice(0, 4).map((step: any) => {
      const processCard: ILeaseProcessCard = {
        title: '',
        subtitle: '',
        srcImg: '',
      };
      processCard.title = step.title_step;
      processCard.subtitle = 'Subtitulo';
      step.img.forEach((img: any) => {
        processCard.srcImg = `${Endpoints.strappi.base}${img.url}`;
      });
      this.leaseProcessCards.push(processCard);
    });
  }

  getCells() {
    if (this.screenWidth < 768) {
      return 1;
    } else if (this.screenWidth < 992) {
      return 2.5;
    } else if (this.screenWidth < 1200) {
      return 3.5;
    } else {
      return 4;
    }
  }

  getArrows() {
    return this.screenWidth < 768
  }
}
